export const styles = theme => ({
    text: {
        marginBottom: "10px"
    }
});
